<template>
	<div class="cod-settings container-fluid">
		<div class="mb-2"><b>COD Settings</b></div>
		<div class="row">
			<!-- Courier -->
			<!-- <div class="col-md-6 hidden">
				<div class="form-group">
					<label>Courier</label>
					<multiselect
						:label="'label'"
						:track-by="'key'"
						:options="couriers"
						:preselect-first="false"
						:show-labels="false"
						:allow-empty="false"
						v-model="value">
					</multiselect>
				</div>
			</div> -->
			<!-- Percentage -->
			<div class="col-md-6">
				<div class="form-group">
					<label><b>Courier Fee Percentage</b></label>
					<div class="input-group">
						<price-input
							class="form-control"
							:min="0"
							:max="100"
							:format="'float'"
							v-model="value.percentage">
						</price-input>
						<div class="input-group-append">
							<span class="input-group-text">%</span>
						</div>
					</div>
				</div>
			</div>
			<!-- Fee Type -->
			<div class="col-md-6">
				<div class="form-group">
					<label><b>Fee Type</b></label>
					<select class="form-control" v-model="value.feeType">
						<option value="product">Product Only</option>
						<option value="product_shipping">Product + Shipping</option>
					</select>
				</div>
			</div>
			<!-- Minimal -->
			<div class="col-md-6">
				<div class="form-group">
					<label><b>Courier Minimal Fee</b></label>
					<price-input
						class="form-control"
						:min="0"
						v-model.number="value.minimal">
					</price-input>
					<!-- <input type="number" class="form-control" min="0" v-model.number="value.minimal"> -->
				</div>
			</div>
			<!-- Maximal -->
			<div class="col-md-6">
				<div class="form-group">
					<label><b>Courier Maximal Fee</b></label>
					<price-input
						class="form-control"
						:min="0"
						v-model.number="value.maximal">
					</price-input>
					<!-- <input type="number" class="form-control" min="0" v-model.number="value.maximal"> -->
				</div>
			</div>
			<!-- Include Shipping -->
			<div class="col-md-6 mt-2">
				<div class="form-group">
					<label><b>Shipping</b></label>
					<label class="label-block mb-0">
						<input type="checkbox" class="input-checkbox input-checkbox-large" v-model="value.includeShipping">
						<span></span>
						<span class="input-checkbox-text">Include Shipping</span>
					</label>
				</div>
			</div>

			<!-- Couriers -->
			<div
				class="col-md-6 mt-2"
				v-if="value.includeShipping">
				<div class="form-group">
					<label class="d-block"><b>{{ $t('COD Couriers') }}</b></label>
					<div
						class="form-group mb-0">
						<checkbox-toggle
							class="d-inline-block mb-3"
							label="Activate Smart Mode"
							info="Sistem Ostock akan memilihkan kurir COD dengan performa terbaik sesuai kecamatan yang dipilih oleh pembeli"
							:value="isSmart"
							@input="onSmartChange"
						/>
						<!-- v-model="shippingSmartMode" -->
					</div>
					<template v-if="!isSmart">
						<div class="mb-2">{{ selectedCouriersLabel }}</div>
						<button
							type="button"
							class="btn btn-light"
							@click="isCouriersVisible = true">
							{{ $t('Set Couriers') }}
						</button>
					</template>
					<div v-if="isSmart">
						<span>{{ $t('Shipping Smart Mode Activated') }}</span>
						<i
							class="material-icons info has-tooltip hidden"
							v-tooltip="'Sistem Ostock akan memilihkan kurir dengan performa terbaik'">
							info
						</i>
					</div>
				</div>
			</div>

			<!-- Smart COD Couriers -->
			<div
				class="col-md-12 mt-2"
				v-if="isGlobal && value.includeShipping && isHasFeature('filter_smart_couriers')">
				<div class="form-group">
					<label class="d-block">
						<b>{{ $t('Smart COD Couriers') }}</b>
					</label>
					<div class="mb-2">{{ selectedSmartCouriersLabel }}</div>
					<button
						type="button"
						class="btn btn-light"
						@click="isSmartCouriersVisible = true">
						{{ $t('Set Smart Couriers') }}
					</button>
				</div>
			</div>
		</div>

		<div class="modals">
			<!-- COD Couriers -->
			<modal
				size="small-medium"
				@close="isCouriersVisible = false"
				v-if="isCouriersVisible">
				<div slot="header">
					<h3>
						<i class="material-icons">local_shipping</i>
						<span>{{ $t('COD Couriers') }}</span>
					</h3>
				</div>
				<div slot="body">
					<options-list
						:options="shippingCouriers"
						v-model="selectedCouriers">
					</options-list>
				</div>
			</modal>

			<!-- Smart COD Couriers -->
			<modal
				size="small-medium"
				@close="isSmartCouriersVisible = false"
				v-if="isSmartCouriersVisible">
				<div slot="header">
					<h3>
						<i class="material-icons">local_shipping</i>
						<span>{{ $t('Smart COD Couriers') }}</span>
					</h3>
				</div>
				<div slot="body">
					<options-list
						:options="smartShippingCouriers"
						v-model="selectedSmartCouriers">
					</options-list>
				</div>
			</modal>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isArray } from 'highcharts';
import PriceInput from '@/components/PriceInput.vue';
import Modal from '@/components/Modal.vue';
import OptionsList from '@/components/OptionsList.vue';
import CheckboxToggle from '@/components/CheckboxToggle.vue';
import { shippingCouriers } from '@/lib/statics';
import { duplicateVar } from '@/lib/helper';

export default {
	name: 'CodSettings',
	props: {
		value: {
			type: Object,
		},
		couriers: {
			type: Array,
			default: () => [],
		},
		smartCouriers: {
			type: Array,
			default: () => [],
		},
		isSmart: {
			type: Boolean,
			default: false,
		},
		position: {
			type: String,
			default: 'product',
		},
	},
	components: {
		PriceInput,
		Modal,
		OptionsList,
		CheckboxToggle,
	},
	data() {
		return {
			// couriers: duplicateVar(codCouriers),
			isCouriersVisible: false,
			isSmartCouriersVisible: false,
			selectedCouriers: [],
			selectedSmartCouriers: [],
		};
	},
	methods: {
		onSmartChange(value) {
			this.$emit('update:is-smart', value);
		},
	},
	computed: {
		...mapGetters({
			isAdmin: 'isAdmin',
			isHasFeature: 'isHasFeature',
		}),
		shippingCouriers() {
			return shippingCouriers.map((courier) => {
				courier.image = `/images/logo-${courier.key}.png`;
				return courier;
			});
		},
		smartShippingCouriers() {
			const partnerCouriers = ['sap', 'sicepat', 'jne'];
			const filteredCouriers = shippingCouriers.filter(({ key }) => partnerCouriers.includes(key));
			const couriers = filteredCouriers.map((courier) => {
				courier.image = `/images/logo-${courier.key}.png`;
				return courier;
			});
			return couriers;
		},
		selectedCouriersLabel() {
			return shippingCouriers
				.filter(({ key }) => this.selectedCouriers.includes(key))
				.map(({ label }) => label)
				.join(', ');
		},
		selectedSmartCouriersLabel() {
			let label = 'All Couriers';

			if (this.selectedSmartCouriers.length > 0) {
				label = shippingCouriers
					.filter(({ key }) => this.selectedSmartCouriers.includes(key))
					.map(({ label }) => label)
					.join(', ');
			}

			return label;
		},
		isGlobal() {
			return this.position === 'global';
		},
	},
	watch: {
		selectedCouriers(couriers) {
			this.$emit('update:couriers', couriers);
		},
		selectedSmartCouriers(couriers) {
			this.$emit('update:smart-couriers', couriers);
		},
		couriers(selected) {
			this.selectedCouriers = selected;
		},
	},
	created() {
		this.selectedCouriers = duplicateVar(this.couriers);
		if (isArray(this.smartCouriers)) {
			this.selectedSmartCouriers = duplicateVar(this.smartCouriers);
		}
	},
};
</script>
